(() => {
  const instances = new WeakMap();

  class MainProduct {
    constructor(section) {
      this.section = section;
      this.gallery = window.ProductGallery?.create(section) || null;
      this.variants = window.ProductVariants?.create(section) || null;
      this.drawer = window.ProductDrawer?.create(section) || null;
      this.purchase =
        window.ProductPurchase?.create(section, { variants: this.variants }) || null;
    }

    destroy() {
      this.purchase?.destroy();
      this.drawer?.destroy();
      this.variants?.destroy();
      this.gallery?.destroy();
    }
  }

  function initialiseProductSections(container = document) {
    const sections = [];

    if (container.matches?.('.main-product')) {
      sections.push(container);
    }

    sections.push(...container.querySelectorAll?.('.main-product') || []);

    sections.forEach((section) => {
      if (instances.has(section)) return;
      instances.set(section, new MainProduct(section));
    });
  }

  function destroyProductSections(container) {
    const sections = [];

    if (container.matches?.('.main-product')) {
      sections.push(container);
    }

    sections.push(...container.querySelectorAll?.('.main-product') || []);

    sections.forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;

      instance.destroy();
      instances.delete(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseProductSections());
  } else {
    initialiseProductSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseProductSections(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyProductSections(event.target);
  });
})();
